/* eslint-disable indent */
/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

export const proposalValidationSchema = Yup.object().shape({
  vietnameseName: Yup.string().required('proposal.create.validationError'),
  researchFieldIds: Yup.array()
    .of(Yup.string())
    .nullable()
    .min(1, 'proposal.create.atLeastOneResearchField')
    .required('proposal.create.validationError'),
  yearProposed: Yup.string().required('proposal.create.validationError'),
  target: Yup.string().required('proposal.create.validationError'),
  type: Yup.string().required('proposal.create.validationError'),
  file: Yup.mixed()
    .required('proposal.create.validationError')
    .test('fileRequired', 'Mục này không được để trống', (value) => value),
  owner: Yup.object({
    ownerId: Yup.string().required('formControl.validation.required'),
    email: Yup.string(),
    fullname: Yup.string().required('formControl.validation.required'),
    contact: Yup.lazy((value) => {
      if (typeof value === 'object') {
        return Yup.object({
          email: Yup.string(),
        }).nullable();
      }
      return Yup.mixed();
    }),
    academicRank: Yup.string().nullable(),
    academicDegree: Yup.string(),
    organizationId: Yup.string(),
    organizationEnglishName: Yup.string(),
    specificOrganizationName: Yup.string().nullable().when('organizationEnglishName', {
      is: 'Other',
      then: Yup.string(),
    }),
  }),
});

export const ownerSchema = Yup.object({
  email: Yup.string().email('formControl.validation.emailInvalid'),
  fullname: Yup.string().required('formControl.validation.required'),
  contact: Yup.lazy((value) => {
    if (typeof value === 'object') {
      return Yup.object({
        id: Yup.string().required('formControl.validation.required'),
        fullname: Yup.string('formControl.validation.required'),
      })
        .required('formControl.validation.required')
        .nullable();
    }
    if (typeof value === 'string') {
      return Yup.string().email('formControl.validation.emailInvalid');
    }
    return Yup.mixed();
  }),
  academicDegree: Yup.string().required('formControl.validation.required'),
  organizationId: Yup.string().required('formControl.validation.required'),
  organizationEnglishName: Yup.string().nullable(),
  specificOrganizationName: Yup.string()
    .nullable()
    .when('organizationEnglishName', {
      is: 'Other',
      then: Yup.string().required('formControl.validation.required'),
    }),
});
